import { render } from "./ReviewConfirmModal.vue?vue&type=template&id=a84a2054&scoped=true"
import script from "./ReviewConfirmModal.vue?vue&type=script&lang=js"
export * from "./ReviewConfirmModal.vue?vue&type=script&lang=js"

import "./ReviewConfirmModal.vue?vue&type=style&index=0&id=a84a2054&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shame\\.codex\\.chatgpt-projects\\g-p-6a9e6467fc748191a03e695eb5ba59d5\\build-work\\hr-dependent-frontend\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84a2054"]])

export default __exports__